<template>
  <div>
    <b-row class="card">
      <div class="w-100 p-3">
        <b-row>
          <b-col lg="4">
            <b-form-group label="Nome da cidade">
              <b-form-input v-model="filters.name" placeholder="Digite o nome da cidade..." />
            </b-form-group>
          </b-col>
        </b-row>

        <b-table responsive bordered :items="filteredCities" :busy="loading" :fields="columnsTableCities">
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Carregando...</strong>
            </div>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex justify-content-center">
              <b-button variant="warning" class="mr-2" @click="setCityToEdit(data.item)">
                <i class="fas fa-edit"></i> Editar
              </b-button>
            </div>
          </template>
        </b-table>

        <b-modal :title="formFields.name" id="edit-percentage">
          <b-form>
            <b-row>
              <b-col lg="4" v-for="(form, index) in formFields.city_panels" :key="index">
                <b-form-group :label="form.panel.brand.toUpperCase()">
                  <b-input-group append="%">
                    <b-form-input v-model="form.percentage_sale" type="number" />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>

          <template #modal-footer>
            <b-button variant="secondary" @click="$bvModal.hide('edit-percentage')">Cancelar</b-button>
            <b-button variant="primary" @click="save(formFields)">Salvar</b-button>
          </template>
        </b-modal>
      </div>
    </b-row>
  </div>
</template>

<script>
import panelService from '@/Services/PanelService';
import HelperService from '@/Services/HelperService';
import ConfigAdminService from '@/Services/ConfigAdminService';

export default {
  props: ['province_id'],

  data() {
    return {
      columnsTableCities: ConfigAdminService.getFieldsTableCities(),
      cities: [],
      panels: [],
      formFields: { name: '', city_panels: [] },
      loading: false,
      filters: {
        name: '',
      },
    };
  },

  computed: {
    filteredCities() {
      if (!this.filters.name) return this.cities;

      const term = this.filters.name.toLowerCase();
      return this.cities.filter(
        (city) => city.name && city.name.toLowerCase().includes(term),
      );
    },
  },

  methods: {
    setCityToEdit(city) {
      if (!city.city_panels || city.city_panels.length === 0) {
        // eslint-disable-next-line no-param-reassign
        city.city_panels = this.panels.map((panel) => ({
          panel,
          percentage_sale: '',
        }));
      }

      this.formFields = {
        ...city,
        city_panels: city.city_panels.map((cp) => ({
          ...cp,
          percentage_sale: cp.percentage_sale
            ? parseFloat((cp.percentage_sale * 100).toFixed(2))
            : '',
        })),
      };

      this.$bvModal.show('edit-percentage');
    },

    async fetchCities() {
      this.loading = true;
      try {
        const { data } = await HelperService.getCities({
          province_id: this.province_id,
        });

        this.cities = data.map((city) => ({
          ...city,
          name: city.name || '',
        }));

        await this.fetchPanels(); // aguarda carregar painéis antes de montar tabela
      } catch (error) {
        console.error('Erro ao buscar cidades:', error);
      } finally {
        this.loading = false;
      }
    },

    async fetchPanels() {
      try {
        const { data } = await panelService.getActivePanels();
        this.panels = data;

        // monta colunas dinâmicas
        data.forEach((item) => {
          this.columnsTableCities.push({
            key: item.brand.toLowerCase(),
            label: item.brand.toUpperCase(),
            thClass: 'text-center',
            tdClass: 'text-center',
          });
        });

        this.columnsTableCities.push({
          key: 'actions',
          label: 'Ações',
          thClass: 'text-center',
          tdClass: 'text-center',
        });

        // vincula percentuais às cidades
        this.cities = this.cities.map((city) => {
          const cityWithPanels = { ...city };
          data.forEach((panel) => {
            const match = city.city_panels?.find(
              (cp) => cp.city_id === city.id && cp.panel_id === panel.id,
            );
            cityWithPanels[panel.brand.toLowerCase()] = match
              ? `${parseFloat((match.percentage_sale * 100).toFixed(2))} %`
              : '-----';
          });
          return cityWithPanels;
        });
      } catch (error) {
        console.error('Erro ao buscar painéis:', error);
      }
    },

    save(item) {
      const payload = item.city_panels.map((panel) => ({
        city_id: item.id,
        panel_id: panel.panel.id,
        percentage_sale: panel.percentage_sale / 100,
      }));

      panelService
        .updateCityPanels(payload)
        .then(() => {
          this.$bvModal.hide('edit-percentage');
          this.$toast.success('Percentuais atualizados com sucesso!');
          this.fetchCities();
        })
        .catch(() => {
          this.$toast.error('Erro ao atualizar percentuais. Tente novamente mais tarde.');
        });
    },
  },

  async created() {
    await this.fetchCities();
  },
};
</script>
